import PropTypes from 'prop-types'
import React from 'react'

import HeaderContainerGrid from '@/components/headerContainer/Grid'
import { ConfigureButton, HeaderActions, HeaderSeparator, ReportDatePicker, RunButton } from '@/components/reports/header'

const propTypes = {
  onClickFilter: PropTypes.func,
  onChangeDates: PropTypes.func,
  dates: PropTypes.object,
  sync: PropTypes.func,
  isLoading: PropTypes.bool,
}

const ReportsFailureHeader = ({ onClickFilter, onChangeDates, dates, sync, isLoading }) => <>
  <HeaderContainerGrid title='Failure Report'>
    <HeaderActions>
      <ReportDatePicker dates={dates} onChange={onChangeDates} />
      <HeaderSeparator />
      <ConfigureButton onClick={onClickFilter} />
      <RunButton onClick={sync} isLoading={isLoading} disabled={isLoading} />
    </HeaderActions>
  </HeaderContainerGrid>
</>

ReportsFailureHeader.propTypes = propTypes

export default ReportsFailureHeader
